import { ApiClientService } from './ApiClientService';

type FeedbackSource = 'main';

export const sendFeedback = async (
  comment: string,
  source: FeedbackSource = 'main'
): Promise<void> => {
  await ApiClientService.postJson<void>(`${ApiClientService.getApiBaseUrl()}/sendFeedback`, {
    comment,
    source,
  });
};
